import { createReducer } from '@reduxjs/toolkit'
import {
  setCallbackFromCreationPage,
  setEditorState,
  setHasClipboardImage,
  setIsOpenErrorModalRemoveBg,
  setZoomRatio,
  setDisableEditorState,
  setIsOpenInspector,
  setLoaderText,
  setCanvasInteractionState,
} from './action'
import { DisableEditorState, EditorUIState, CanvasInteractionState, defaultEditorUIState, defaultEnabledEditorState, defaultCanvasInteractionState } from '@/constants/app-options'
import { ActionType } from './actionTypes'

export { ActionType }
export type ClipboardType = '' | 'internal' | 'external'
export interface EditorState {
  zoomRatio: number
  isOpenErrorModalRemoveBg: boolean
  hasClipboardImage: ClipboardType
  callbackFromCreationPage: {
    action: ActionType
    value?: any,
    analytic?: any
  }
  disableEditorState: DisableEditorState
  editorState: EditorUIState
  canvasInteractionState: CanvasInteractionState
  isOpenInspector: boolean
}
const initialState: EditorState = {
  zoomRatio: 1,
  isOpenErrorModalRemoveBg: false,
  hasClipboardImage: '',
  callbackFromCreationPage: null,
  disableEditorState: defaultEnabledEditorState,
  editorState: defaultEditorUIState,
  canvasInteractionState: defaultCanvasInteractionState,
  isOpenInspector: false,
}

export const editorReducer = createReducer(initialState, builder => {
  builder.addCase(setZoomRatio, (state, { payload }) => {
    state.zoomRatio = payload
  })
  builder.addCase(setIsOpenErrorModalRemoveBg, (state, { payload }) => {
    state.isOpenErrorModalRemoveBg = payload
  })
  builder.addCase(setHasClipboardImage, (state, { payload }) => {
    state.hasClipboardImage = payload
  })
  builder.addCase(setCallbackFromCreationPage, (state, { payload }) => {
    state.callbackFromCreationPage = payload
  })
  builder.addCase(setDisableEditorState, (state, { payload }) => {
    state.disableEditorState = payload
  })
  builder.addCase(setEditorState, (state, { payload }) => {
    state.editorState = payload
  })
  builder.addCase(setIsOpenInspector, (state, { payload }) => {
    state.isOpenInspector = payload
  })
  builder.addCase(setCanvasInteractionState, (state, { payload }) => {
    state.canvasInteractionState = payload
  })
  builder.addCase(setLoaderText, (state, action) => {
    const payload = action.payload as { texts: string[]; style?: 'gradient'; minWidth?: string; animationType?: import('@/constants/app-options').LoaderTextAnimationType } | null
    if (!payload || !payload.texts?.length) {
      state.editorState.loaderText = null
    } else {
      state.editorState.loaderText = {
        texts: payload.texts,
        style: payload.style ?? 'gradient',
        minWidth: payload.minWidth,
        animationType: payload.animationType,
      }
    }
  })
})